module.exports = __webpack_public_path__ + "static/img/jx.332569d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx.png
// module id = wUK+
// module chunks = 0